// @flow

import * as React from 'react';

import SearchResultPlaceholder from './SearchResultPlaceholder';

type Props = {|
  nResults?: number,
|};

function SearchResultsPlaceholder({ nResults = 5 }: Props) {
  return Array(nResults)
    .fill(0)
    .map((_, index) => index)
    .map(key => <SearchResultPlaceholder key={key} />);
}

export default (React.memo(
  SearchResultsPlaceholder
): React.AbstractComponent<Props>);
